export type SavedCorrectionCalculation = 'Calagem' | 'Fosfatagem' | 'Gessagem';

export const formatCalculationList = (calculations: SavedCorrectionCalculation[]): string => {
	if (calculations.length <= 1) return calculations[0] ?? '';
	return `${calculations.slice(0, -1).join(', ')} e ${calculations[calculations.length - 1]}`;
};

export const buildCalculationsSavedMessage = (
	calculations: SavedCorrectionCalculation[]
): string => {
	const calculationList = formatCalculationList(calculations);
	if (calculations.length === 1) return `${calculationList} foi salva com sucesso!`;
	if (calculations.length > 1) return `${calculationList} foram salvas com sucesso!`;
	return 'Recomendação salva com sucesso!';
};
